import { DetailedHTMLProps, forwardRef, LabelHTMLAttributes, memo, ReactNode, useId } from "react";
import classNames from "classnames";
import { RadioButtonBase, RadioButtonBaseProps } from "../RadioButtonBase";

import styles from "./styles.module.scss";

export type RadioButtonSize = "sm" | "md";

export type RadioButtonProps = Omit<RadioButtonBaseProps, "radioButtonBaseSize"> & {
  radioButtonBaseClassName?: string,
  radioButtonSize?: RadioButtonSize,
  supportingText?: ReactNode,
  labelProps?: Omit<DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>, "className">
  text: ReactNode,
}

export const RadioButton = memo(forwardRef<HTMLSpanElement, RadioButtonProps>((
  {
    radioButtonBaseClassName,
    radioButtonSize= "md",
    text,
    supportingText,
    className,
    disabled,
    id,
    labelProps,
    ...props
  }, ref,
) => {
  const reactId = useId();
  const realId = id || reactId;

  return (
    <label
      {...labelProps}
      className={classNames(
        styles.root,
        className,
        styles[radioButtonSize as keyof typeof styles],
        {
          [styles.hasSupportingText]: !!supportingText,
          [styles.disabled]: disabled,
        },
      )}
      htmlFor={realId}
    >
      <RadioButtonBase
        ref={ref}
        radioButtonBaseSize={radioButtonSize}
        className={classNames(styles.radioButtonBase, radioButtonBaseClassName)}
        disabled={disabled}
        id={realId}
        {...props}
      />
      <span className={styles.text}>
        {text}
      </span>
      {
        !!supportingText &&
        <span className={styles.supportingText}>
          {supportingText}
        </span>
      }
    </label>
  );
}));